import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/327b8615-4552-41f1-9829-9e6b7ac3041a/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/327b8615-4552-41f1-9829-9e6b7ac3041a/src/design-system/layout/Main.tsx");
